function shouldStartOnSecondSlide() {
  try {
    return new URLSearchParams(window.location.search).get('homepageSliderFirst') === 'true';
  } catch (e) {
    return false;
  }
}

function removeHomepageSliderFirstParam() {
  try {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('homepageSliderFirst')) return;
    url.searchParams.delete('homepageSliderFirst');
    var cleanUrl = url.pathname + url.search + url.hash;
    window.history.replaceState(window.history.state, '', cleanUrl);
  } catch (e) {}
}

function initFreshnessHeroSliders(root) {
  var $ = window.jQuery;
  if (!$ || !$.fn.slick) return;

  var scope = root || document;
  var sections = scope.matches && scope.matches('.freshness-hero')
    ? [scope]
    : scope.querySelectorAll('.freshness-hero');
  var startOnSecond = shouldStartOnSecondSlide();

  sections.forEach(function (section) {
    var slider = section.querySelector('.freshness-hero-slider--multiple');
    if (!slider) return;

    var $slider = $(slider);
    if ($slider.hasClass('slick-initialized')) return;

    var slideCount = parseInt(section.dataset.slideCount, 10) || slider.children.length;
    var initialSlide = startOnSecond && slideCount > 1 ? 1 : 0;

    if (initialSlide === 1) {
      slider.classList.add('homepage-slider-first');
    }

    // Let CSS control height (fixed on desktop/tablet, image-driven on mobile)
    slider.style.height = '';
    slider.style.minHeight = '';

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: isMobile,
      initialSlide: initialSlide,
      autoplay: section.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(section.dataset.autoplaySpeed, 10) || 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      appendDots: $slider
    });
  });

  if (startOnSecond) {
    removeHomepageSliderFirstParam();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initFreshnessHeroSliders();
});

document.addEventListener('shopify:section:load', function (event) {
  initFreshnessHeroSliders(event.target);
});
